import Axios from 'axios';
import { getOrgTree } from '@/api/orgMana'

export default {
  state: () => {
    return {
      orgTreeSourceData: []
    }
  },
  getters: {
    orgAutoCompletedSourceData: state => {
      const autoCompletedSourceData = [];
      state.orgTreeSourceData.forEach(item => {
        autoCompletedSourceData.push(...generateAutoCompletedSourceData(item, null, true))
      });

      return autoCompletedSourceData
    },
    orgTreeDownSelectionData: state => {
      return generateDownSelectionData(state.orgTreeSourceData)
    }
  },
  mutations: {
    setOrgTreeSourceData(state, data) {
      state.orgTreeSourceData = data;
    }
  },
  actions: {
    // 获取系统所用的组织树数据内容
    async getOrgTreeSourceData(context, data) {
      try {
        const res = await getOrgTree()
        const treeSourceData = []

        res.data.collection.forEach(item => {
          treeSourceData.push(treeDataAddScopedSlots(item))
        });
        context.commit('setOrgTreeSourceData', treeSourceData)
        
        return Promise.resolve(res)
      } catch (error) {
        return Promise.reject(error)
      }
    }
  }
}

// 为获取的组织树内容添加 scopedSlots，以便自定义树形式
function treeDataAddScopedSlots(org) {
  let node = {
    ...org,
    scopedSlots: { title: 'custom' }
  };

  if (org.children && org.children.length) {
    node.children = [];
    org.children.forEach(subOrg => {
      node.children.push(treeDataAddScopedSlots(subOrg))
    });
  };
  return node
}

// 通过组织树数据 treeSourceData，生成组织自动补全搜索的数据源 orgAutoCompletedSourceData
function generateAutoCompletedSourceData(org, prevData, mixNodeName) {
  let prevNameList = [];
  let prevOrgExpandedList = [];

  if (prevData) {
    prevNameList = prevData.nameList;
    prevOrgExpandedList = prevData.expandedList;
  }

  let nameList = [].concat(prevNameList, [org.name])
  let tempArr = [{
    id: org.id,
    name: mixNodeName ? nameList.join('/') : org.name,
    nameList: nameList,
    expandedList: [].concat(prevOrgExpandedList, [org.id])
  }];

  if (org.children && org.children.length) {
    org.children.forEach(subOrg => {
      tempArr.push(...generateAutoCompletedSourceData(subOrg, tempArr[0], mixNodeName))
    });
  }
  return tempArr
}

// 通过组织树数据 treeSourceData，生成组织下拉选择的数据源 orgTreeDownSelectionData
function generateDownSelectionData(org) {
  let treeData = [];

  treeData = org.map(item => {
    return {
      value: item.id,
      fullName: item.fullName,
      label: item.name,
      children: item.children,
      selectable: true
    }
  })

  treeData.forEach(item => {
    if (item.children && item.children.length) {
      item.children = generateDownSelectionData(item.children)
    }
  })

  return treeData
}